import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTRPC } from 'src/utils/trpc';

export interface LinkItemsTRPCInput {
  Source: string;
  Targets: string[];
}

export const useLinkItemsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const { addNotification } = useNotifications();

  const mutation = useMutation({
    ...trpc.frontend.linkedItem.link.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.linkedItem.linkedItems.queryKey(),
        });
      },
    }),
    throwOnError: true,
  });

  useEffect(() => {
    if (mutation.error) {
      addNotification({
        type: 'error',
        content: mutation.error.message,
      });
    }
  }, [mutation.error, addNotification]);

  const linkItems = async (input: LinkItemsTRPCInput) => {
    await mutation.mutateAsync(input);
  };

  return {
    linkItems,
    loading: mutation.isPending,
    error: mutation.error,
  };
};
